import React from "react";

import style from "./styles.module.scss";

interface SectionHeaderProps {
  label: string;
  title: string;
}

export default function SectionHeader({ label, title }: SectionHeaderProps) {
  return (
    <header className={style.sectionHeader}>
      <span aria-hidden="true" className={style.ornament} />
      <div className={style.texts}>
        <h2 className={`pgm-label-large ${style.label}`}>{label}</h2>
        <p className={`pgm-title-large ${style.title}`}>{title}</p>
      </div>
    </header>
  );
}
